































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
class DisabledCard extends Vue {
  @Prop({
    type: String,
    default: '',
  })
  readonly number: string
}

export default DisabledCard
